import React from 'react'
import Image from 'next/image'

import { Row, Rows, Column } from '@/components/layout'
import arrowsIconImg from '@/assets/buy-flow/right-side/arrows-icon.png'
import emailAccessDocImg from '@/assets/buy-flow/right-side/email--access-doc.png'
import emailSearchFilesImg from '@/assets/buy-flow/right-side/email--search-files.png'
import emailFileProtectionImg from '@/assets/buy-flow/right-side/email--file-protection.png'

import styles from './CheckoutSideEmail.module.scss'

export default function CheckoutSideEmail() {
  return (
    <Column center className={styles.background} gap={32} size={66}>
      <Row className={styles.pinkBox}>
        <Column>
          <Rows className={styles.left} gap={32}>
            <Rows gap={12}>
              <Image alt="" className={styles.neatLogo} src={arrowsIconImg} />
              <h1>Simplify How You Work</h1>
            </Rows>
            <p>Neat extracts the key information from your receipts and documents, integrates with popular accounting and business software.</p>
          </Rows>
        </Column>
        <Column>
          <Rows className={styles.statsRows} gap={32}>
            <Rows className={styles.stats}>
              <div>
                <h2>24/7</h2>
                <Image alt="" src={emailAccessDocImg} />
              </div>
              <p>Access documents anytime, anywhere</p>
            </Rows>

            <Rows className={styles.stats}>
              <div>
                <h2>10x</h2>
                <Image alt="" src={emailSearchFilesImg} />
              </div>
              <p>More efficiency in searching for files</p>
            </Rows>

            <Rows className={styles.stats}>
              <div>
                <h2>100%</h2>
                <Image alt="" src={emailFileProtectionImg} />
              </div>
              <p>File protection from natural disasters</p>
            </Rows>
          </Rows>
        </Column>
      </Row>
    </Column>
  )
}
